
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmForgotPasswordApi } from "../../../../utils/apis/auth-service";

export const useNewPassword = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const email = location.state?.email as string;
    const code = location.state?.code as string;

    const [isLoading, setIsLoading] = useState(false);

    const onBackButtonClick = async () => {
        navigate("/forgot-password-insert-code", { state: { email } })
    }

    const handleInputsSubmit = async (inputData: { [key: string]: string }) => {
        setIsLoading(true)
        const password = inputData.password

        confirmForgotPasswordApi(
            email,
            password,
            code,
            async () => {
                setIsLoading(false)
                navigate("/login", { state: { email, password } })
            },
            async (error) => {
                setIsLoading(false)
            }
        )
    }

    return {
        onBackButtonClick,
        handleInputsSubmit,
        isLoading,
    }
}